import React, { useEffect } from 'react';
import usePageMeta from '../hooks/usePageMeta';
import styles from './bodytext.module.css';

const NotFound = () => {
  usePageMeta(
    'Page Not Found | Vintage in Oulton',
    "Sorry, we couldn't find the page you were looking for."
  );

  useEffect(() => {
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute('content', 'noindex');

    return () => {
      // Other pages should stay indexable - remove the tag on unmount
      robotsMeta.remove();
    };
  }, []);

  return (
      <div className={styles.textContainer}>
        <h2>Page Not Found</h2>
        <p>Sorry, we couldn't find the page you were looking for.</p>
        <br />
        <p><a href="/">Return to Home</a></p>
      </div>
  );
};

export default NotFound;
